import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=f6c3442c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c3442c')) {
      api.createRecord('f6c3442c', component.options)
    } else {
      api.reload('f6c3442c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=f6c3442c&", function () {
      api.rerender('f6c3442c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26v8HCBm4d7RV/JS/comp/childrenage.vue"
export default component.exports